<script>
	import { DialogNew, Icon, CodeSnippet } from '@shopboxai/sb-portal-components';
	import { clientID, continueTour, endTour } from '../../../utils/utils.js';
	export let data = {
		id: null,
		currency: 'EUR',
		rows: 4
	};
	let sbScript = ` <script async src="https://grid.shopbox.ai/sbgrid.min.js"></\script>`;
	$: code = `
  <div style="--sb-rows: ${
		Math.ceil(data.rows / 4) || 1
	}; min-height: calc(240px * var(--sb-rows));">
     <shopbox-grid cid="${$clientID}" currency="${data.currency || 'EUR'}" id="${
		data.id
	}"></shopbox-grid>
  </div>
  `;
</script>

<DialogNew data={code} on:submit on:close maxWidth="600px">
	<div slot="header">Embed code</div>
	<div slot="content">
		<label for="">Script</label>
		<!-- <textarea class="sb-script tour-step-14" value={sbScript} /> -->
		<div class="tour-step-14">
			<CodeSnippet language="html" code={sbScript} />
		</div>
		<label for="">HTML</label>
		<div class="tour-step-15">
			<CodeSnippet language="html" {code} />
		</div>
		<!-- <textarea class="tour-step-15" value={code} /> -->
	</div>
	<button class="primary" slot="primary-action" on:click={endTour}>Copy Grid Code</button>
	<button
		slot="toggle"
		class="tour-step-13-{data.id}"
		on:click={() => continueTour(13)}
		title="Copy grid code"><Icon name="code" /></button
	>
</DialogNew>

<style>
	.sb-script {
		height: 100px;
	}
</style>
